import type { Id } from '@/infra/id'

interface JobDetailsDestination {
  type: 'JobDetails'
  jobId: string
}

interface DashboardDestination {
  type: 'Dashboard'
}

interface WaitlistDestination {
  type: 'Waitlist'
}

interface WidgetDestination {
  type: 'Widget'
}

export type Destination =
  | JobDetailsDestination
  | DashboardDestination
  | WaitlistDestination
  | WidgetDestination

/**
 * The navigation options used in the session.
 */
export type NavbarOptions = { kind: 'Default' } | { kind: 'None' }

/**
 * The default navigation options.
 */
export const NavbarOptions = {
  default: {
    kind: 'Default',
  } as NavbarOptions,
}

/**
 * The session options for the current user.
 */
export interface SessionOptions {
  readonly navbarOptions: NavbarOptions
  readonly returnOptions: ReturnOptions | null
  readonly allowedLegendIds: Id[] | null
  readonly destination: Destination
}

/**
 * Options for returning to a partner.
 */
export interface ReturnOptions {
  readonly url: string
  readonly actionLabel: string
}

/**
 *  The session options type with default values.
 */
export const SessionOptions = {
  default: {
    navbarOptions: NavbarOptions.default,
    returnOptions: null,
    allowedLegendIds: null,
    destination: { type: 'Dashboard' },
  } as SessionOptions,
}
